(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evolt-auth-coupon-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'evolt-auth-coupon-requested-at';
    const loginTriggerSelector = 'a.discount-gated__message, a.discount-gated__reveal';
    const requestLifetime = 60 * 60 * 1000;

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const loginTrigger = event.target.closest(loginTriggerSelector);
        if (!loginTrigger) return;

        try {
          sessionStorage.setItem(storageKey, Date.now().toString());
        } catch (error) {
          // Storage can be unavailable in strict privacy modes; sign-in must still continue.
        }

        const popup = document.getElementById('EvoltAuthCoupon');
        const storefrontLoginUrl = popup?.dataset.storefrontLoginUrl;
        if (!storefrontLoginUrl) return;

        event.preventDefault();
        window.location.assign(storefrontLoginUrl);
      },
      true
    );

    const initializeCouponPopup = () => {
      const popup = document.getElementById('EvoltAuthCoupon');
      if (!popup) return;

      let requestedAt = 0;
      try {
        requestedAt = Number(sessionStorage.getItem(storageKey)) || 0;
      } catch (error) {
        return;
      }

      const requestIsRecent = requestedAt > 0 && Date.now() - requestedAt <= requestLifetime;
      if (popup.dataset.customerAuthenticated !== 'true' || !requestIsRecent) {
        if (requestedAt > 0 && !requestIsRecent) sessionStorage.removeItem(storageKey);
        return;
      }

      sessionStorage.removeItem(storageKey);

      const dialog = popup.querySelector('[role="dialog"]');
      const copyButton = popup.querySelector('[data-evolt-coupon-copy]');
      const copyLabel = popup.querySelector('[data-evolt-copy-label]');
      const copiedText = popup.querySelector('[data-evolt-copied-text]');
      const copyStatus = popup.querySelector('[aria-live]');
      const closeButtons = popup.querySelectorAll('[data-evolt-coupon-close]');
      const previousFocus = document.activeElement;
      const previousOverflow = document.body.style.overflow;

      const closePopup = () => {
        popup.hidden = true;
        document.body.style.overflow = previousOverflow;
        document.removeEventListener('keydown', handleKeydown);
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      };

      const handleKeydown = (event) => {
        if (event.key === 'Escape') closePopup();
      };

      const copyCode = async () => {
        const code = popup.dataset.couponCode;

        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          const textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }

        copiedText.hidden = false;
        copyStatus.textContent = copiedText.textContent.trim();
        copyLabel.hidden = true;
      };

      closeButtons.forEach((button) => button.addEventListener('click', closePopup));
      copyButton.addEventListener('click', copyCode);
      document.addEventListener('keydown', handleKeydown);

      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      dialog.focus();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCouponPopup, { once: true });
    } else {
      initializeCouponPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
